import { buildApiUrl } from '../config';
import useAPI from '../../hooks/useAPI';
import { useState } from 'react';
import { z } from 'zod';

// Import existing types to use in function signatures
import { FortnoxTokenSetupRequestSchema } from '../schemas/userSchemas';

/**
 * Hook for setting up Fortnox tokens with built-in state management
 * Includes Zod validation for type safety
 */
export const useSetupFortnoxTokens = () => {
  const { callAPI } = useAPI();

  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<any>(null);

  /**
   * Setup Fortnox tokens
   * @param authCode - The auth code from Fortnox
   * @param callbackUri - The callback URI
   * @param integrationType - The integration type (base/salary)
   * @returns Promise with boolean indicating success
   */
  const action = async (
    authCode: string,
    callbackUri: string,
    integrationType: string
  ): Promise<boolean> => {
    setIsLoading(true);
    setError(null);
    try {
      // Validate the request data
      const validatedRequest = /* FortnoxTokenSetupRequestSchema.parse( */ {
        authCode,
        callbackUri,
        integrationType,
      }; /* ); */

      await callAPI(
        buildApiUrl(
          `fortnoxToken/authCode/${authCode}/callbackUri/${callbackUri}/integrationType/${integrationType}`
        ),
        validatedRequest
      );
      return true;
    } catch (error) {
      console.error('Error in useSetupFortnoxTokens:', error);
      setError(error);
      return false;
    } finally {
      setIsLoading(false);
    }
  };

  return {
    isLoading,
    error,
    action,
  };
};
